import isEvent from './isEvent';

var silenceEvent = function silenceEvent(event) {
  var is = isEvent(event);

  if (is) {
    event.preventDefault();
  }

  return is;
};

export default silenceEvent;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/events/silenceEvent.js
// module id = uD/v
// module chunks = 1